export const twitterData = [
  {
    text: 'PR TIMES STORY',
    href: 'https://twitter.com/PRTIMES_STORY',
    color: '#000000',
  },
  {
    text: 'PR TIMES TV',
    href: 'https://twitter.com/PRTIMES_TV',
    color: '#294C7A',
  },
  {
    text: 'ニュース',
    href: 'https://twitter.com/PRTIMES_NEWS',
    color: '#eeeeee',
  },
  {
    text: 'テクノロジー',
    href: 'https://twitter.com/PRTIMES_TECH',
    color: '#585858',
  },
  {
    text: 'アプリケーション',
    href: 'https://twitter.com/PRTIMES_APP',
    color: '#e30f0f',
  },
  {
    text: 'スタートアップ',
    href: 'https://twitter.com/PRTIMES_STUP',
    color: '#8791b5',
  },
  {
    text: 'エンタメ',
    href: 'https://twitter.com/PRTIMES_ETM',
    color: '#edc81e',
  },
  {
    text: 'ビューティー',
    href: 'https://twitter.com/PRTIMES_BEAUTY',
    color: '#f292b8',
  },
  {
    text: 'ファッション',
    href: 'https://twitter.com/PRTIMES_FASHION',
    color: '#ed7014',
  },
  {
    text: 'ライフスタイル',
    href: 'https://twitter.com/PRTIMES_LIFE',
    color: '#ed7014',
  },
  {
    text: 'トラベル',
    href: 'https://twitter.com/PRTIMES_TRAVEL',
    color: '#73c150',
  },
  {
    text: 'グルメ',
    href: 'https://twitter.com/PRTIMES_GOURMET',
    color: '#ee6760',
  },
  {
    text: 'ゲーム',
    href: 'https://twitter.com/PRTIMES_GAMES',
    color: '#8a83d0',
  },
  {
    text: 'スポーツ',
    href: 'https://twitter.com/PRTIMES_SPORTS',
    color: '#1d8db9',
  },
  {
    text: 'ビデオ',
    href: 'https://twitter.com/PRTIMES_VIDEO',
    color: '#ff8985',
  },
  {
    text: 'ビジネス',
    href: 'https://twitter.com/PRTIMES_BIZ',
    color: '#4775b4',
  },
  {
    text: 'マーケティング',
    href: 'https://twitter.com/PRTIMES_MKTG',
    color: '#6a7591',
  },
];
